export const isObjectEmpty = (obj: any): boolean => {
  return Object.keys(obj).length === 0;
};

const addValueToObj = (
  obj: any,
  nestedKeys: Array<string>,
  value: string
): void => {
  const lastKeyIndex = nestedKeys.length - 1;
  for (let i = 0; i < lastKeyIndex; i++) {
    const key = nestedKeys[i];
    if (!(key in obj)) {
      obj[key] = {};
    }
    obj = obj[key];
  }
  obj[nestedKeys[lastKeyIndex]] = value;
};
export interface IdValueObject {
  id: string;
  value: string;
}
export const convertArrayToObject = (
  arr: Array<IdValueObject>,
  nestedIdDelimiter: string
): any => {
  return arr.reduce((obj, currItem) => {
    const nestedKeys = currItem.id.split(nestedIdDelimiter);
    addValueToObj(obj, nestedKeys, currItem.value);
    return obj;
  }, {});
};

export const getNestedObjectProperty = (obj: object, key: string): any => {
  const keyParts = key.split('.');
  const property = keyParts.reduce((result, currItem) => {
    if (!result) {
      return null;
    }

    result = result[currItem];
    return result;
  }, obj);

  return property;
};

export const getTwoFieldComparisonResult = <T>(
  field1: T,
  field2: T
): boolean => {
  return field1 === field2 ? true : false;
};

export const getThreeFieldComparisonResult = <T>(
  field1: T,
  field2: T,
  field3: T
): boolean => {
  return field1 === field2 && field2 === field3 ? true : false;
};

export const getMarkedCellClass = (markClass: boolean): string => {
  return markClass ? 'mw-marked-cell' : '';
};

export const isNullOrUndefined = (obj: any): boolean => {
  return typeof obj === 'undefined' || obj === null;
};
